import React, { FC, ReactElement } from "react"
import { MeanWithStd } from "../types"
import { Card } from "antd"
import { Link } from "react-router-dom"
import { FlexCol, FlexRow } from "../components/commons-ts/common"
import { COLOR_BG_DARK, COLOR_BG_GRAY, COLOR_BG_LIGHT_BLUE, colorHexToRgba } from "./utils"

export const renderMeanStd = (
  meanStdValue: MeanWithStd,
  minCount: number,
  n?: number,
): ReactElement => {
  if (n === undefined) {
    n = 0
  }
  return (
    <span>
      <b>{meanStdValue.mean.toFixed(n)}</b>&nbsp;±&nbsp;
      {meanStdValue.std.toFixed(n + 1)}
      {/* &nbsp; */}
      {/* {meanStdValue.count && `[${meanStdValue.count}]`} */}
      {/* {meanStdValue.count && meanStdValue.count < minCount && (
                <Tooltip
                    overlay={
                        <span>
                            <Translated keyEn="Not enough impacts to compute a reliable mean and standard deviation" />
                            &nbsp;({"< "}
                            {minCount})
                        </span>
                    }
                >
                    <WarningFilled
                        style={{
                            color: "orange",
                        }}
                    />
                </Tooltip>
            )} */}
    </span>
  )
}

export const CardLink: FC<{
  to: string
  icon: JSX.Element
  title: JSX.Element
  description: JSX.Element
}> = ({ to, title, description, icon }) => {
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Card
        style={{
          backgroundColor: colorHexToRgba(COLOR_BG_LIGHT_BLUE, 0.2),
          padding: 10,
        }}
        hoverable={true}
      >
        <FlexCol
          style={{
            gap: 0,
            color: COLOR_BG_DARK,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FlexRow
            style={{
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div style={{ fontSize: "1.2rem" }}>{title}</div>
            <div style={{ fontSize: "1.5rem" }}>{icon}</div>
          </FlexRow>
          {description}
        </FlexCol>
      </Card>
    </Link>
  )
}
